<template>
  <Dialog class="role-input" :open="isOpen" hide-title>
    <div class="content">
      <div class="content-area">
        <p>1、游戏内点击左上角头像，打开角色信息面板。</p>
        <p>2、点击角色ID旁的复制按钮，即可一键复制角色信息。</p>
        <p>3、将角色信息粘贴至输入框内，完成识别。</p>
        <img src="../../../assets/howGet.png">
      </div>
      <div class="close-area" @click="close"></div>
    </div>
  </Dialog>
</template>

<script>
import Dialog from "@/components/dialog/index.vue";
export default {
  components: {
    Dialog,
  },
  emits: ["close"],
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    open() {
      this.isOpen = true;
    },
    close() {
      this.isOpen = false;
      this.$emit("close");
    },
    help() {
      window.location.href = "https://wxaurl.cn/CuttQMXo4zf";
    },
  },
};
</script>

<style lang="scss" scoped>
.role-input {
  :deep(.outer) {
    .dialog {
      width: 26rem;
      height: 26rem;
      min-width: 26rem;
      background: url(../../../assets/help.png) no-repeat center;
      background-size: contain;
    }
  }
  .content {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    .content-area {
      position: relative;
      width: 16.5rem;
      height: 15rem;
      top: 3rem;
      box-sizing: border-box;
      padding: 0.5rem;
      overflow: auto;
      user-select: none;
      &::-webkit-scrollbar {
        display: none;
      }
      -ms-overflow-style: none;
      scrollbar-width: none;
      p{
        color: #493e86;
        font-size: 1rem;
        margin: 1rem 0;
      }
      img{
        width: 100%;
      }
    }
    .close-area {
      cursor: pointer;
      position: relative;
      top: 6.5rem;
      width: 3.5rem;
      height: 3.5rem;
    }
    .help {
      position: relative;
      top: -3rem;
      left: -3.5rem;

      padding: 2rem;
      color: #493e86;
    }
  }
}
</style>
